// extracted by mini-css-extract-plugin
module.exports = {"root":"ShowAllTenantDocuments_root__1K1Qz","button":"ShowAllTenantDocuments_button__17MTW"};